var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadphones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M383.1 256L352 256.1c-17.62 0-32 14.38-32 32v159.9c0 17.62 14.38 32.05 32 32.05l31.99 .0156C419.4 480 448 451.3 448 415.9v-95.75C448 284.8 419.4 256 383.1 256zM416 415.9c0 17.62-14.38 32.13-32 32.13h-32V288l32 .0417c17.62 0 32 14.5 32 32.13V415.9zM160 256.1L127.1 256C92.62 256 64 284.8 64 320.2v95.75c0 35.38 28.62 64.09 63.99 64.09L160 480c17.62 0 32-14.42 32-32.05V288.1C192 270.4 177.6 256.1 160 256.1zM160 448.1H128c-17.62 0-32-14.5-32-32.13v-95.75c0-17.62 14.38-32.13 32-32.13l32-.0417V448.1zM243 32.38C105.5 39.21 0 157.9 0 295.5v104.5c0 8.801 7.201 16 16 16c8.801 0 16-7.168 16-15.97V294.6C32 174.1 124.4 70.3 244.7 64.34C373.3 57.98 480 160.8 480 288.1v112c0 8.801 7.201 15.97 16 15.97c8.801 0 16-7.199 16-16V287.1C512 142.5 390 25.08 243 32.38z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/headphones.b98ad030c01f05abb0742d44ad8321aa.svg";
export { ForwardRef as ReactComponent };